import { createElement } from 'react';
import cx from 'classnames';
import { Tab } from '@alifd/next';
import './index.scss';
export const TabContainer = (props) => {
    const { className, ...restProps } = props;
    const CustomTabItem = (key, props) => {
        return createElement("div", { className: "navigation" }, key.title);
    };
    return (createElement(Tab, { className: cx(className, 'fusion-ui-tab'), ...restProps, tabRender: (key, props) => createElement(CustomTabItem, { key: key, ...props }) }));
};
TabContainer.displayName = 'TabContainer';
